export class ClasseProfit {

	public debiteurEtranger: string;
	public departement: string;
	public etablissementsPublicsSante: string;
	public autresOrganismesPublics: string;
	public commune: string;
	public debiteurPrivePersMorale: string;
	public groupementCollectivites: string;
	public debiteurPrivePersPhysique: string;
	public region: string;
	public etat: string;

	constructor() {
		this.debiteurEtranger = '';
		this.departement = '';
		this.etablissementsPublicsSante = '';
		this.autresOrganismesPublics = '';
		this.commune = '';
		this.debiteurPrivePersMorale = '';
		this.groupementCollectivites = '';
		this.debiteurPrivePersPhysique = '';
		this.region = '';
		this.etat = '';

	}
}
